var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 122,
    viewBox: "0 0 98 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0129 41.436L75.8878 41.436C76.8527 41.4375 77.8163 41.5042 78.7721 41.6356C89.2041 43.1082 96.9698 52.0257 96.9994 62.5662V99.3584C96.9644 111.009 87.5329 120.446 75.8878 120.481H22.1116C10.4634 120.446 1.03067 111.004 1 99.3504L1 62.5662C1.03355 52.0287 8.79834 43.1157 19.2273 41.6436C20.1831 41.5123 21.1468 41.4457 22.1116 41.444L52.2271 41.6436",
    fill: "#47DDDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0129 41.436L75.8878 41.436C76.8527 41.4375 77.8163 41.5042 78.7721 41.6356C89.2041 43.1082 96.9698 52.0257 96.9994 62.5662V99.3584C96.9644 111.009 87.5329 120.446 75.8878 120.481H22.1116C10.4634 120.446 1.03067 111.004 1 99.3504L1 62.5662C1.03355 52.0287 8.79834 43.1157 19.2273 41.6436C20.1831 41.5123 21.1468 41.4457 22.1116 41.444L52.2271 41.6436",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44141 57.7421C10.2491 53.7309 13.3521 50.5778 17.3483 49.7075",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0904 104.413C88.2894 108.429 85.1865 111.588 81.1875 112.46",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6953 85.8877L29.1421 98.0813",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0645 88.3696L30.72 94.3846",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4609 90.0273L25.3824 98.964",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7742 86.5747L19.7969 99.4628",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1255 86.8413L19.2891 94.385",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5696 91.2812L25.7266 97.5357",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7753 30.0091V41.6359C77.8197 41.5027 76.8559 41.436 75.891 41.4363H70.5533V29.3266C70.5533 17.7517 60.9071 8.33609 49.0109 8.33609C37.1067 8.33609 27.4685 17.7317 27.4685 29.3266V41.4363H22.1148C21.1499 41.4358 20.1861 41.5025 19.2305 41.6359L19.2305 30.0091C19.2305 13.9878 32.5628 1 49.0029 1C65.443 1 78.7753 13.9878 78.7753 30.0091Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3047 9.31006C63.9891 9.78828 64.6445 10.3067 65.2674 10.8627L63.3047 9.31006Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3047 9.31006C63.9891 9.78828 64.6445 10.3067 65.2674 10.8627",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.416 6.10498C58.2292 6.59097 59.9723 7.30867 61.6022 8.24035L56.416 6.10498Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.416 6.10498C58.2292 6.59097 59.9723 7.30867 61.6022 8.24035",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9994 73.7817V83.361H78.9277C77.9957 83.361 77.2402 82.6051 77.2402 81.6726V75.4701C77.2402 74.5376 77.9957 73.7817 78.9277 73.7817L96.9994 73.7817Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9434 83.0417L84.4938 73.7817",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.957 83.3496L90.7309 73.7783",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1699 83.3535L96.9598 73.7583",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7616 79.231L55.0967 91.8796C55.1476 92.0704 55.1068 92.274 54.9864 92.4304C54.866 92.5869 54.6797 92.6783 54.4823 92.6779H43.2723C43.0751 92.6787 42.8888 92.5871 42.769 92.4304C42.6491 92.2737 42.6095 92.0698 42.6619 91.8796L46.0569 79.2071C46.0956 79.0274 46.0067 78.8445 45.8414 78.764C42.63 77.3076 40.8723 73.8042 41.6236 70.3575C42.375 66.9108 45.4313 64.4579 48.9572 64.4717C52.4831 64.4855 55.5201 66.9623 56.2445 70.4147C56.9689 73.8672 55.1838 77.3567 51.9611 78.788C51.8021 78.8735 51.7202 79.0552 51.7616 79.231Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7676 61.2136C53.363 60.8019 56.8139 62.7555 58.3127 66.0511",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.d39756eee454c8caad293e06824a57bb.svg";
export { ForwardRef as ReactComponent };